import content from './en_content';
import errorMessages from './en_errormessages';
import metadata from './en_metadata';

const messageTemplates = Object.assign(
	{},
	content.messageTemplates,
	errorMessages.messageTemplates,
	metadata.messageTemplates,
);
export default { messageTemplates };



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/i18n/lang/en/index.js